import React, { Component } from 'react';
import Idle from 'react-idle';
import { connect, Provider } from 'react-redux';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core';
import { CircularProgress } from 'material-ui';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import decode from 'jwt-decode';

import RenderDialog from './helpers/RenderDialog';
import RenderTimeoutDialog from './helpers/RenderTimeoutDialog';
import ComponentMap from './helpers/ComponentMap';
import { ProductMap, ProductMapReversed } from './helpers/ProductMap';

import getConfig from './actions/getConfig';
import getRoutes from './actions/getRoutes';
import getPerson from './actions/getPerson';
import getUserLocations from './actions/getUserLocations';
import signOut from './actions/signOut';
import { store, persistor } from './store';
import { isObjectEmpty, hasJwtTokenExpired  } from './helpers/Util';
import IconMap from './helpers/IconMap';
import './App.css';
import { ClearCacheProvider } from 'react-clear-cache';
import { PersistGate } from 'redux-persist/lib/integration/react';

import Header from './components/Header';

class App extends Component {
  static getCompanyFromUrl() {
    let company = App.getParameterByName('c', window.location.href);
    if (!company || (company !== '' && company !== 'rmt' && company !== 'autotec')) {
      company = '';
    }

    localStorage.setItem('company', company);
  }

  static getSSOFromUrl() {
    return App.getParameterByName('ssoProvider', window.location.href);
  }

  static getParameterByName(name, url) {
    const nn = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${nn}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static renderLogin() {
    return (
        <BrowserRouter>
          <Switch>
            <Route component={ComponentMap.Home} />
          </Switch>
        </BrowserRouter>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
        logout: false,
        fetchingLocations: false,
        isSSOLogin: false,
        ssoFetchingDone: false,
        waitingForCognito: false,
        timeoutWarning: false,
        openDialog: false
    };
  }

  componentWillMount() {
    App.getCompanyFromUrl();
    this.props.actions.getConfig(this);
  }

  componentDidUpdate(prevProps) {
    // Making sure that when navigating away from the page that was previously timedout on
    // the iniformation that was saved is cleared from the redux store.
    if (!isObjectEmpty(prevProps.data.prevFormData)
      && !sessionStorage.getItem('timedout')
      && sessionStorage.getItem('previousRoute') !== window.location.pathname) {
        this.props.actions.clearTimeoutFormData();
    }
  }

  getSessionTimeout() {
    const { LogoutTimeout } = this.props.data.config;

    return LogoutTimeout;
  }

  handleErrorDialog() {
    const { error } = this.props.data.error || {};
    const token = localStorage.getItem('jwtToken');
    if (!error && !(hasJwtTokenExpired(token))) return null;
    
    let errorMessage = '';
    try {
      if (error.response && error.response.data) {
          errorMessage = String(error.response.data.message);
      } else if (error.message) {
          errorMessage = error.message;
      } else {
          errorMessage = String(error);
      }
    } catch (e) {
      console.log(e)
    }
    let sessionExpired = false;
    if(errorMessage === 'Unauthorized' || (token && hasJwtTokenExpired(token))) {
      errorMessage = 'Your session has expired, please login to continue.';
      sessionExpired = true;
    }
    console.log(errorMessage);
    return (<RenderDialog
        open
        confirmButton
        message={errorMessage}
        onClose={() => {
          this.props.actions.closeErrorDialog();
          if (sessionExpired || errorMessage.includes('Invalid FilterExpression')) {
            this.logout();
          }
        }}
    />);
  }

  logout() {
    this.props.actions.signOut(this.props.data.config);
  }

  debugLogin(authenticated) {
    // the purpose of this is to allow the app to reload w/o having to go through
    // authentication again. We store the login info and person in local storage
    // and play this back through dispatches to set the state properly.
    // the config.debug flag should NOT be set to true in production
    if (!this.props.data.config.debug || localStorage.getItem('signedout')) {
      return authenticated;
    }

    let authed = authenticated;
    const dt = localStorage.getItem('login');
    const person = localStorage.getItem('person');

    // if localstorage is not set and login is fetched, persist this info in localstorage
    if (!dt && this.props.data.login && this.props.data.login.fetched) {
      localStorage.setItem('login', JSON.stringify(this.props.data.login));
    }

    if (!person && this.props.data.person && this.props.data.person.fetched) {
      localStorage.setItem('person', JSON.stringify(this.props.data.person.person));
    }

    // if we have a login in local storage, hydrate it and dispatch the login action with it
    // keep in mind that sessions can expire in cognito, so the logout function clears
    // all the local storage.
    if (dt) {
      try {
        const dtJson = JSON.parse(dt);
        authed = dtJson.authenticated;
        if (!this.props.data.login.fetched) {
          this.props.actions.debugLogin(dtJson.login, this.props.data.config);
        }
      } catch (error) {
        localStorage.removeItem('login');
      }
    }

    if (person && !this.props.data.person.fetched) {
      try {
        const dtPerson = JSON.parse(person);
        this.props.actions.debugPerson(dtPerson, this.props.data.config);
      } catch (error) {
        localStorage.removeItem('person');
      }
    }
    
    return authed;
  }

  allowRefresh(authenticated) {
    let auth = authenticated;

    if (localStorage.getItem('signedout')) {
      return auth;
    }

    const loggedIn = localStorage.getItem('login');
    const loginPerson = localStorage.getItem('person');
    
    // if localstorage is not set and login is fetched, persist this info in localstorage
    if (!loggedIn && this.props.data.login && this.props.data.login.fetched) {
      localStorage.setItem('login', JSON.stringify(this.props.data.login));
    }

    if (!loginPerson && this.props.data.person && this.props.data.person.fetched) {
      localStorage.setItem('person', JSON.stringify(this.props.data.person.person));
    }


    if (loggedIn) {
      try {
        const dtJson = JSON.parse(loggedIn);
        auth = dtJson.authenticated;
        if (!this.props.data.login.fetched) {
          this.props.actions.allowRefresh(dtJson.login, this.props.data.config);
        }
      } catch (error) {
        localStorage.removeItem('login');
      }
    }

    if (loginPerson && !this.props.data.person.fetched) {
      try {
        const dtPerson = JSON.parse(loginPerson);
        this.props.actions.loginPerson(dtPerson, this.props.data.config);
      } catch (error) {
        localStorage.removeItem('person');
      }
    }
    
    return auth;
  }

  checkSSORedirect() {
    localStorage.setItem('isSSOLogin', false);

    // the redirect back contains the token
    // https://<url>/#access_token=<access token>&id_token=<id token>&token_type=Bearer&expires_in=3600
    const idToken = App.getParameterByName('id_token', window.location.href);
    
    if (idToken) {
      const decoded = decode(idToken);
      console.log(decoded);
      localStorage.setItem('authenticated', true);
      localStorage.setItem('isSSOLogin', true);
      localStorage.setItem('jwtToken', idToken);
      localStorage.setItem('signedout', false);
      localStorage.setItem('login', JSON.stringify('{ authenticated: true }'));
      if (!this.state.fetchingLocations) {
        console.log(`getting locations for: ${decoded.sub}`);
        this.props.actions.getSSOUserLocations(this.props.data.config, this, decoded.sub);
      }
    }
  }

  renderLocationSelector() {
    return (
        <BrowserRouter>
          <div>
            {this.handleErrorDialog()}
            <Route path="/" component={ComponentMap.LocationSelector} />
          </div>
        </BrowserRouter>
    );
  }

  renderSelector() {
    return (
        <BrowserRouter>
          <div>
            {this.handleErrorDialog()}
            <Route path="/selector" component={ComponentMap.Selector} />
            {this.renderIdleComponent()}
            {this.state.timeoutWarning ? this.renderTimeoutDialog() : null}
          </div>
        </BrowserRouter>
    );
  }

  renderProductSelector() {
    return (
        <BrowserRouter>
          <div>
            {this.handleErrorDialog()}
            <Route path="/" component={ComponentMap.ProductSelector} />
            {this.renderIdleComponent()}
            {this.state.timeoutWarning ? this.renderTimeoutDialog() : null}
          </div>
          
        </BrowserRouter>
    );
  }

  handleDialogTimeoutSignOut() {
    this.setState({ timeoutWarning: false });
    this.logout();
  }

  handleIdleTimeout() {
    this.setState({ timeoutWarning: false });
    this.logout();
  }

  renderTimeoutDialog() {
    return (<RenderTimeoutDialog
      open={this.state.timeoutWarning}
      signOutAction={() => { this.handleDialogTimeoutSignOut(); }}
      staySignedInAction={() => { this.setState({ timeoutWarning: false }); }}
      handleIdleTimeout={() => { this.handleIdleTimeout(); }}
      timeoutInterval={this.props.data.config.WarningTimeout}
    />);
  }

  renderIdleComponent() {
    const timeout = this.getSessionTimeout();
    return (
            <Idle
              timeout={timeout}
              onChange={({ idle }) => {
                if (idle) {
                  // do not logout when using sso. sso handles token expiration on it's own
                  const isSSOLogin = localStorage.getItem('isSSOLogin') ? JSON.parse(localStorage.getItem('isSSOLogin')) : false;
                  if (!isSSOLogin && !localStorage.getItem('signedout')) {
                    this.setState({ timeoutWarning: true });
                  }
                }
              }}
            />
          );
    }

    showDataRetentionScreen(routes) {
        if (routes.find(r => r.key === 'data-retention-search')) return false;
  
        const { person } = this.props.data.person;
        if (!person) return false;
  
        const autotecLocation = person.locations.find(l => l.autotecId === 'ACDV0036');
        if (!autotecLocation) return false;
  
        const { name: roleName } = autotecLocation.role;
        if (!roleName || roleName !== 'sysadmin') return false;
  
        return true;
      }

  renderRoutes(currentLocationId, currentProduct) {
    const { routes } = this.props.data;
    const { person } = this.props.data.person;

    if (!routes) {
      this.props.actions.getRoutes(person, currentLocationId, currentProduct);

      return <div align="center"><CircularProgress size={75} /></div>;
    }

    if (this.showDataRetentionScreen(routes) && !routes.some(route => route.key === 'data-retention-search')) {
      routes.push({
        component: ComponentMap.DataRetentionSearch,
        icon: IconMap.SearchIcon,
        key: 'data-retention-search',
        order: 99,
        path: '/data-retention/search',
        text: 'Search Report History'
      });
    }

    return (
        <BrowserRouter>
          <div>
            {this.handleErrorDialog()}
            {this.state.timeoutWarning ? this.renderTimeoutDialog() : null}
            <Switch>
              {
                routes &&
                routes
                    .filter(r => r.path && r.component)
                    .map(r => (
                        <Route exact key={r.key} path={r.path} component={r.component} />
                    ))
              }
            </Switch>
            {this.renderIdleComponent()}
          </div>
        </BrowserRouter>
    );
  }
  render() {
    const { isSSOLogin, ssoFetchingDone } = this.state;
    const { region } = this.props.data.config;
    let latestBuild = sessionStorage.getItem('latestBuild');

    if (!region || (isSSOLogin && !ssoFetchingDone)) {
      return (
        <div>
          <div align="center">
            <CircularProgress size={100} style={{ marginTop: '10%' }} />
          </div>
        </div>
      );
    }

    const authenticated = (isSSOLogin || this.allowRefresh(this.props.data.login.authenticated) || this.debugLogin(this.props.data.login.authenticated));

    if (!authenticated) {
      const ssoProvider = App.getSSOFromUrl() ? App.getSSOFromUrl().replace('\'', '') : null;
      const product = App.getParameterByName('product', window.location.href);
      if (product) {
        console.log(`Setting product: ${product}`);
        sessionStorage.setItem('product', ProductMapReversed[product.toLowerCase()]);
      }

      if (this.state.logout) {
        return (<RenderDialog
          open={this.state.logout}
          confirmButton
          message="Your session has timed out. Any unsaved changes have been lost. Please log in again."
          onClose={() => this.setState({ logout: false })}
      />);
      }

      const ssoUrl = `${this.props.data.config.ssoUrl}/oauth2/authorize?identity_provider=${ssoProvider}&redirect_uri=${this.props.data.config.ssoRedirectUrl}&response_type=TOKEN&client_id=${this.props.data.config.ssoClientId}&amp&scope=email+openid`;
      // log out the ssoUrl as it is usefull for debugging because this redirect
      // is quickly redirected to another place
      console.log(ssoUrl);
      if (ssoProvider) {
        window.location.href = ssoUrl;
      }
      else {
        return App.renderLogin();
      }
    }
    
    const currentLocationId = localStorage.getItem('locationId');
    const currentProduct = sessionStorage.getItem('product');
    const signedOut = localStorage.getItem('signedout');
    //If the variable latestBuild is not set in session storage, trigger a refresh.
    //This gets cleared on logout or time out, so this will trigger on every login.
    if (!latestBuild) {
      return (<ClearCacheProvider filename={"meta.json"} auto={!latestBuild}>
        <BrowserRouter>
          <Switch>
            <Header />
          </Switch>
        </BrowserRouter>
        <div align="center">
          <CircularProgress size={75}></CircularProgress>
        </div>
      {sessionStorage.setItem('latestBuild', true)}
     </ClearCacheProvider>);
    }


    if (!currentLocationId && !signedOut) {
      return this.renderLocationSelector();
    }
    if (!currentProduct && !signedOut) {
      return this.renderProductSelector();
    }
    else if(window.location.href.includes('/selector')) {
      return this.renderSelector();
    }
    
    return this.renderRoutes(currentLocationId, currentProduct);
  }
}
const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    login: state.login,
    person: state.person,
    routes: state.routes.routes,
    error: state.error
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getSSOUserLocations: (config, self, cognitoId) => {
      self.setState({ fetchingLocations: true, isSSOLogin: true, ssoFetchingDone: false });
      dispatch(getUserLocations(config, self)).then((locations) => {
        if (locations && locations.value && locations.value.data) {
          // pick the first location, sso users should only have one
          // autogenerated location
          localStorage.setItem('locationId', locations.value.data[0].locationId);
          localStorage.setItem('customerId', locations.value.data[0].customerId);
          // get the person
          dispatch(getPerson(null, cognitoId, config)).then((result) => {
            self.setState({ ssoFetchingDone: true });
          });
        } else {
          console.log('No locations found for user');
        }
        self.setState({ fetchingLocations: false });
      });
    },
    getConfig: (self) => {
      dispatch(getConfig(self)).then((result) => {
        self.checkSSORedirect();
      });
    },
    getRoutes: (person, locationId, productId) => {
      if (!person) return;
      const location = person.locations.find(l => l.locationId === locationId) || undefined;
      const product = ProductMap[productId];
      dispatch(getRoutes(location, product));
    },
    signOut: (config) => {
      dispatch(signOut(config));
    },
    closeErrorDialog: () => {
      dispatch({
        type: 'ERROR_DIALOG_CLOSED',
        payload: null
      });
    },
    debugLogin: (login) => {
      console.log('debug login');
      dispatch({
        type: 'LOGIN_FETCH_FULFILLED',
        payload: login
      });
    },
    debugPerson: (person) => {
      console.log('debug person');
      dispatch({
        type: 'PERSON_FETCH_FULFILLED',
        payload: { data: { person } }
      });
    },
    allowRefresh: (login) => {
      dispatch({
        type: 'LOGIN_FETCH_FULFILLED',
        payload: login
      });
    },
    loginPerson: (person) => {
      dispatch({
        type: 'PERSON_FETCH_FULFILLED',
        payload: { data: { person } }
      });
    },
    getPerson: (email, cognitoId, config) => {
      dispatch(getPerson(email, cognitoId, config));
    },
    clearTimeoutFormData: () => {
      dispatch({
        type: 'TIMEOUT_SIGNOUT_USER_FETCH_CLEAR',
        payload: {}
      });
    }
  }
});

const ConnectedApp = connect(
    mapStateToProps,
    mapDispatchToProps
)(App);

const generateClassName = createGenerateClassName();
const jss = create(jssPreset());

// wrap ConnectedApp component with JssProvider to prevent CSS class naming collisions
const ConnectedProviderApp = () => (
    <Provider store={store}>
      <PersistGate loading={<CircularProgress size={75} />} persistor={persistor}>
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <ConnectedApp />
        </JssProvider>
      </PersistGate>
    </Provider>
);

export default ConnectedProviderApp;


// WEBPACK FOOTER //
// ./src/App.js